var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmailCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_66_14698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 40C10 43.9397 10.776 47.8407 12.2836 51.4805C13.7913 55.1203 16.001 58.4274 18.7868 61.2132C21.5726 63.999 24.8797 66.2087 28.5195 67.7164C32.1593 69.224 36.0603 70 40 70C43.9397 70 47.8407 69.224 51.4805 67.7164C55.1203 66.2087 58.4274 63.999 61.2132 61.2132C63.999 58.4274 66.2087 55.1203 67.7164 51.4805C69.224 47.8407 70 43.9397 70 40C70 36.0603 69.224 32.1593 67.7164 28.5195C66.2087 24.8797 63.999 21.5726 61.2132 18.7868C58.4274 16.001 55.1203 13.7913 51.4805 12.2836C47.8407 10.776 43.9397 10 40 10C36.0603 10 32.1593 10.776 28.5195 12.2836C24.8797 13.7913 21.5726 16.001 18.7868 18.7868C16.001 21.5726 13.7913 24.8797 12.2836 28.5195C10.776 32.1593 10 36.0603 10 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_66_14698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.6667 49.3307H30.6667C29.9594 49.3307 29.2811 49.0498 28.781 48.5497C28.281 48.0496 28 47.3713 28 46.6641V33.3307C28 32.6235 28.281 31.9452 28.781 31.4451C29.2811 30.945 29.9594 30.6641 30.6667 30.6641H49.3333C50.0406 30.6641 50.7189 30.945 51.219 31.4451C51.719 31.9452 52 32.6235 52 33.3307V41.3307",
    stroke: "#41A1EA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 33.3359L40 41.3359L52 33.3359",
    stroke: "#41A1EA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 49.3307L46.6667 51.9974L52 46.6641",
    stroke: "#41A1EA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_66_14698"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_66_14698"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(24 24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmailCheck);
export default __webpack_public_path__ + "static/media/icon-email-check.e719cd9e6123d02c0cb96c30ea00acb5.svg";
export { ForwardRef as ReactComponent };